/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import templateOnly from '@ember/component/template-only';

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface UnlockBoxLoadingScreenSignature {}

export default templateOnly<UnlockBoxLoadingScreenSignature>();
